import { createAction, props } from '@ngrx/store';

// Load Responses
export const loadResponses = createAction(
  '[Responses] Load Responses',
  props<{ botId: string; collection: string }>()
);

export const loadResponsesSuccess = createAction(
  '[Responses] Load Responses Success',
  props<{ responses: any[]; botId: string }>()
);

export const loadResponsesFailure = createAction(
  '[Responses] Load Responses Failure',
  props<{ error: string }>()
);

// Load Flow Data for Responses
export const loadFlowData = createAction(
  '[Responses] Load Flow Data',
  props<{ botId: string; responseId: string; flowIds: string[] }>()
);

export const loadFlowDataSuccess = createAction(
  '[Responses] Load Flow Data Success',
  props<{ responseId: string; linkedFlows: any[] }>()
);

export const loadFlowDataFailure = createAction(
  '[Responses] Load Flow Data Failure',
  props<{ responseId: string; error: string }>()
);

// Search Responses
export const setSearchQuery = createAction(
  '[Responses] Set Search Query',
  props<{ query: string }>()
);

// Filter Responses
export const filterResponses = createAction(
  '[Responses] Filter Responses',
  props<{ query: string }>()
);

// Add Response
export const addResponse = createAction(
  '[Responses] Add Response',
  props<{ response: any }>()
);

export const addResponseSuccess = createAction(
  '[Responses] Add Response Success',
  props<{ response: any }>()
);

export const addResponseFailure = createAction(
  '[Responses] Add Response Failure',
  props<{ error: string }>()
);

// Update Response
export const updateResponse = createAction(
  '[Responses] Update Response',
  props<{ responseId: string; updates: any }>()
);

export const updateResponseSuccess = createAction(
  '[Responses] Update Response Success',
  props<{ response: any }>()
);

export const updateResponseFailure = createAction(
  '[Responses] Update Response Failure',
  props<{ error: string }>()
);

// Delete Response
export const deleteResponse = createAction(
  '[Responses] Delete Response',
  props<{ responseId: string }>()
);

export const deleteResponseSuccess = createAction(
  '[Responses] Delete Response Success',
  props<{ responseId: string }>()
);

export const deleteResponseFailure = createAction(
  '[Responses] Delete Response Failure',
  props<{ error: string }>()
);

// Clear Responses
export const clearResponses = createAction(
  '[Responses] Clear Responses'
);

// Set Loading States
export const setLoading = createAction(
  '[Responses] Set Loading',
  props<{ isLoading: boolean }>()
);

export const setAddingAction = createAction(
  '[Responses] Set Adding Action',
  props<{ isAddingAction: boolean }>()
);

// Selected Response Actions
export const setSelectedResponse = createAction(
  '[Responses] Set Selected Response',
  props<{ response: any }>()
);

export const clearSelectedResponse = createAction(
  '[Responses] Clear Selected Response'
);

// Selected Child Actions
export const setSelectedChild = createAction(
  '[Responses] Set Selected Child',
  props<{ child: any }>()
);

export const clearSelectedChild = createAction(
  '[Responses] Clear Selected Child'
);
export const setDisableAddMessage = createAction(
  '[Responses] Set Disable Add Message',
  props<{ disabled: boolean }>()
);
export const setResponseButtonsData = createAction(
  '[Responses] Set Response Buttons Data',
  props<{ 
    responseId: string;
    buttons: any[];
    typebutton: any[];
    typeActionsButton: any[];
  }>()
);

export const setResponseQuickRepliesData = createAction(
  '[Responses] Set Response Quick Replies Data',
  props<{ 
    responseId: string;
    quickReplies: any[];
    typeQuickbutton: any[];
    typeActionsQuickReply: any[];
  }>()
);

export const clearResponseData = createAction(
  '[Responses] Clear Response Data',
  props<{ responseId: string }>()
);

export const clearAllResponseData = createAction(
  '[Responses] Clear All Response Data'
);